import { KeyValue } from "@/main/models/common";
import { CompanyTypeRequest } from "@/main/models/request/companyTypeRequest";

export enum CompanyTypeTypes {
	GET_COMPANY_TYPE = "@companyType/GET_COMPANY_TYPE",
	SAVE_COMPANY_TYPE = "@companyType/SAVE_COMPANY_TYPE",
	RESET_REDUCER_COMPANY_TYPE = "@companyType/RESET_REDUCER_COMPANY_TYPE",
	GET_COMPANY_TYPE_PUBLIC = "@companyType/GET_COMPANY_TYPE_PUBLIC",
	SAVE_COMPANY_TYPE_PUBLIC = "@companyType/SAVE_COMPANY_TYPE_PUBLIC",
}

export interface CompanyTypeState {
	readonly companyType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};

	readonly companyTypePublic: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetCompanyType {
	type: typeof CompanyTypeTypes.GET_COMPANY_TYPE;
	payload: CompanyTypeRequest | null;
}

export interface SaveCompanyType {
	type: typeof CompanyTypeTypes.SAVE_COMPANY_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface GetCompanyTypePublic {
	type: typeof CompanyTypeTypes.GET_COMPANY_TYPE_PUBLIC;
}

export interface SaveCompanyTypePublic {
	type: typeof CompanyTypeTypes.SAVE_COMPANY_TYPE_PUBLIC;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerCompanyType {
	type: typeof CompanyTypeTypes.RESET_REDUCER_COMPANY_TYPE;
}

export type CompanyTypeActionTypes =
	| GetCompanyType
	| SaveCompanyType
	| ResetReducerCompanyType
	| GetCompanyTypePublic
	| SaveCompanyTypePublic;
